import { render, staticRenderFns } from "./block-documents-api-action-results.vue?vue&type=template&id=8df0cdc6&scoped=true&lang=pug"
import script from "./block-documents-api-action-results.vue?vue&type=script&lang=js"
export * from "./block-documents-api-action-results.vue?vue&type=script&lang=js"
import style0 from "./block-documents-api-action-results.vue?vue&type=style&index=0&id=8df0cdc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df0cdc6",
  null
  
)

export default component.exports